export const Thunderbolt = Symbol.for('Thunderbolt')
export const NavigationInfoSym = Symbol.for('NavigationInfo')
